import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { DeviationResourceType } from '../../../types/deviation';
import { useVerification } from '../../../VerificationPopup/withVerification';
const ShareInPost = ({ deviation, stopPropagation, shareToPost })=>{
    const { t } = useTranslation();
    const { restrictToVerifiedAndLoggedIn } = useVerification();
    const restrictedShareToPost = restrictToVerifiedAndLoggedIn(ReferralType.SHARE_TO_POST, 'submitstatus', shareToPost);
    return /*#__PURE__*/ React.createElement(ListItemButton, {
        label: t('deviationview.tierCard.moreActionsMenu.item.shareInPost'),
        onClick: restrictedShareToPost,
        stopPropagation: stopPropagation,
        biData: BiData({
            evid: 356,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            social_share: 'da_post',
            deviationid: deviation.deviationId
        }),
        fillContainerWidth: true
    });
};
ShareInPost.displayName = 'ShareInPost';
export default ShareInPost;

//# sourceMappingURL=ShareInPost.js.map